import { Store, AnyAction, Unsubscribe } from 'redux'
import { Selector } from 'react-redux'
import { ReduxState } from '@/config/redux/types'

type OnStoreChange<T> = (state: T, store: Store<ReduxState, AnyAction>) => void

const observeStore = <T>(
  store: Store<ReduxState, AnyAction>,
  select: Selector<ReduxState, T>,
  onChange: OnStoreChange<T>
): Unsubscribe => {
  let currentState: T = select(store.getState())

  const handleChange = () => {
    const state = store.getState()
    const nextState = select(state)

    if (nextState !== currentState) {
      currentState = nextState
      onChange(currentState, store)
    }
  }

  const unsubscribe = store.subscribe(handleChange)
  handleChange()

  return unsubscribe
}

export default observeStore
